import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { API } from '../../Backend'
import axios from 'axios'

const ResetPassword = () => {

  const [password, setPassword] = useState("")  
  const [errorMessage, setErrorMessage] = useState("")
  const [successMessage, setSuccessMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const {token} = useParams()

  const handleSubmit = async () => {
    if (password.trim().length < 8) {
      setErrorMessage("Password length should be greater than 8")
    } else {
        setLoading(true)
        try {
          const {data} = await axios.post(`${API}/user/resetpassword/${token}`, {password})
          setErrorMessage("")
          setSuccessMessage(data.message)
          setLoading(false)
          setPassword("")
        } catch (error) {
            setErrorMessage(error.response.data.message)
            setSuccessMessage("")
            setPassword("")
            setLoading(false)
        }
    }
  }

  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        document.getElementById("submitBtn").click()
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [])

  return (
    <section className='d-flex align-items-center justify-content-center min-vh-100'>
        <div className='px-8 px-lg-0' style={{maxWidth:"450px"}}>
            <div className="row">
                <img src="/assets/img/logo.png" alt="" />
                <p className='w-100 mt-5'>Please enter your new password</p>
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
                {successMessage && <p className="text-success">{successMessage}</p>}
                <input type="password" name='password' className='form-control' placeholder='New Password' autoComplete='off' value={password} onChange={(e)=>setPassword(e.target.value)} tabIndex={1}/>
                <button className='mt-5 btn btn-primary w-100' onClick={handleSubmit} tabIndex={2}>{loading ? <div className="spinner-border loader-sizing" style={{height:"1.5rem", width:"1.5rem"}} role="status"><span className="sr-only"></span></div>:'Reset Password'}</button>
                <p className='mt-5 text-center w-100 text-secondary'>Go back to <a className='text-primary' href="/login">Login</a> page</p>
            </div>
        </div>
    </section>
  )
}

export default ResetPassword